import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DateTimeUtil } from "../../../utils";
import { ChevronRight, Loader2 } from "lucide-react";
import { setTopNavNameTitle } from "../../../redux/features/mobileLayout/slice";
import { RootState, useAppDispatch } from "../../../redux/store";
import { useSelector } from "react-redux";

interface TodaySchedulePromptProps {
    onPress?: () => void;
}

const TodaySchedule: React.FC<TodaySchedulePromptProps> = ({ onPress }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { isLoadingTodaysSchedule, todaysSchedule: schedule } = useSelector((state: RootState) => state.schedule);
    const [renderNew, setRenderNew] = useState(true);
    
    useEffect(() => {
        console.log("schedule", schedule);
    }, [schedule]);

    const goToCalendar = () => {
        dispatch(setTopNavNameTitle("My Schedule"));
        navigate("/m-calendar");
    };

    return renderNew ? (
        <div className="rounded-lg bg-white w-full" onClick={onPress}>
            <div className="flex">
                {/* <p className="text-base font-medium text-gray-500">Tap to schedule shifts</p> */}
                <p className="text-base text-gray-500">View personal and team schedules, time off, and availability</p>
            </div>
        </div>
    ) : (
        <div className="p-6 rounded-xl border border-gray-300 bg-white mb-4 shadow-sm">
            <div className="flex justify-between items-center" onClick={goToCalendar}>
                <h2 className="text-xl font-semibold text-blue-500">Today's Shifts</h2>
                <ChevronRight className="w-7 h-7 text-blue-600 cursor-pointer" />
            </div>

            {isLoadingTodaysSchedule ? (
                <div className="flex justify-center py-4">
                    <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
                </div>
            ) : schedule ? (
                <div className="mt-6 space-y-4 text-[17px]">
                    <div className="flex justify-between font-medium text-gray-700">
                        <span>{schedule.shift?.shift_name || "Unnamed Shift"}</span>
                        <span className="text-gray-700">
                            {DateTimeUtil.formatTimeRangeUtc(schedule.start_time, schedule.end_time) || "N/A"}
                        </span>
                    </div>

                    {schedule.emp_details?.emp_name && (
                        <div className="flex items-center gap-3 text-gray-700">
                            {schedule.emp_details.image_url && (
                                <img
                                    src={schedule.emp_details.image_url}
                                    alt="Emp"
                                    className="w-10 h-10 rounded-full border border-gray-300"
                                />
                            )}
                            <span className="font-medium">{schedule.emp_details.emp_name}</span>
                        </div>
                    )}

                    {schedule.site?.site_name && (
                        <div className="text-gray-600">
                            📍 <strong>Site:</strong> {schedule.site.site_name}
                        </div>
                    )}

                    {schedule.department?.department_name && (
                        <div className="text-gray-600">
                            🏬 <strong>Department:</strong> {schedule.department.department_name}
                        </div>
                    )}

                    {schedule.workcode?.workcode_name && (
                        <div className="text-gray-600">
                            🏷️ <strong>Workcode:</strong> {schedule.workcode.workcode_name}
                        </div>
                    )}

                    {schedule.notes && <div className="text-gray-600 italic">📝 {schedule.notes}</div>}
                </div>
            ) : (
                <div className="mt-6 font-medium text-gray-500">No schedule today!</div>
            )}
        </div>
    );
};

export default TodaySchedule;